import type React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import type translations from "../../translations/translations.json";
import { rawColor } from "../../constants/colors";

type TranslationKeys = keyof typeof translations.en;

interface LoadingStateProps {
  message?: string;
  fullScreen?: boolean;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  message = "Loading...",
  fullScreen = false,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        ...(fullScreen && {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: rawColor.white.transparent["08"],
          zIndex: 9999,
        }),
      }}
    >
      <CircularProgress size={40} sx={{ mb: 2 }} />
      <Typography variant="body1" color="textSecondary">
        {t(message as TranslationKeys)}
      </Typography>
    </Box>
  );
};

export default LoadingState;
